module.exports = __webpack_public_path__ + "static/media/discover.d0dea7e1.png";